export default __webpack_public_path__ + "static/media/quiz_bg.8a163678.png";